// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"0ebf098c","247":"0ebf098c"}[chunkId] + ".chunk.css";
};